<template>
  <div class="card card-liste-faces reseaux-tempo">
    <div class="card-content" v-if="!isComponentDiapoface">
      <div>
        <a class="is-pulled-right" @click="$parent.close()">
          <b-icon icon="close"></b-icon>
        </a>
        <div class="columns">
          <div class="column is-4 pl-0">
            <article class="media">
              <figure class="media-left">
                <p class="image is-128x128">
                  <img v-if="reseau.urlPhoto" :src="reseau.urlPhoto"/>
                  <img v-else src="@/assets/default-placeholder.png"/>
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <h5 class="is-size-5 has-text-weight-bold">Réseau : {{reseau.libelle}}</h5>
                  <p class="lineHeight is-size-7 has-text-default">
                    Nb de faces: {{reseau.nbrFacesTotal}} <br>
                    <span
                      class="has-text-weight-bold"
                      v-if="reseau.extensionOpportunite && reseau.extensionOpportunite.newPeriode">
                      {{reseau.extensionOpportunite.newPeriode}}
                    </span>
                  </p>
                </div>
              </div>
            </article>
          </div>
          <div class="column">
            <h1 class="subtitle is-pulled-right" v-if="!noUpdate">
              {{reseau.listeFaces.filter((el) => el.selected).length}}
              sur {{reseau.listeFaces.length}} faces sélectionnées </h1>
          </div>
        </div>
        <div class="is-pulled-right">
          <div class="buttons">
            <b-button
              icon-left="content-copy"
              label="Exporter les faces disponibles"
              type="is-primary"
              class="is-size-14px is-height-34px"
              @click="exportFacesDispo()"
              v-if="noUpdate && !horsSecteur"/>
            <b-button
              icon-left="content-copy"
              label="Exporter toutes les faces"
              type="is-primary"
              class="is-size-14px is-height-34px"
              @click="exportCsv(reseau.listeFaces)"
              v-if="noUpdate"/>
            <b-button
              icon-left="content-copy"
              label="Exporter les faces selectionnées"
              type="is-primary"
              class="is-size-14px is-height-34px"
              @click="exportFacesSelect()"
              v-if="!noUpdate"/>
            <b-button
              icon-left="content-copy"
              label="Dupliquer la selection"
              type="is-primary"
              class="is-size-14px is-height-34px"
              @click="isComponentOuvrirCopyListeFaces = true"
              v-if="!noUpdate"/>
          </div>
        </div>
        <b-tabs
          type="is-toggle"
          v-if="dataLoad"
          v-model="valueTabs"
          class="custum-tabs">
          <b-tab-item
            v-if="showAffectations && isAffixe2"
            label="Options / blocages">
            <OptionBlocage
              :affectations="affectations"
              :total-faces="reseau.nbrFacesTotal"
            />
          </b-tab-item>
          <b-tab-item label="Liste">
            <app-liste
              :reseau="reseau"
              :disabled="disabled"
              :generateMarker="generateMarker"
              :noUpdate="noUpdate"
              :horsSecteur="horsSecteur"
              ref="appListe"/>
          </b-tab-item>
          <b-tab-item label="Carte">
            <div class="map-modal__carte-liste-faces-reseau-tempo">
              <gmap-map
                :center="{ lat: reseau.latitude, lng: reseau.longitude }"
                :zoom="12"
                class="googleMap"
                ref="map">

                <div v-if="markers.length">
                  <gmap-marker
                    :key="m.position.lat + '|' + m.position.lng"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="m.clickable"
                    :draggable="false"
                    :icon="m.icon"
                    @click="selecMarker(m)"
                    @mouseover="toggleInfoWindow(m, index)">
                  </gmap-marker>

                  <gmap-info-window
                    :options="infoOptions"
                    :position="infoWindowPos"
                    :opened="infoWinOpen"
                    @closeclick="infoWinOpen=false"
                  >
                    <div class="" v-html="infoContent"></div>
                  </gmap-info-window>
                </div>

              </gmap-map>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
    <b-modal
      v-model="isComponentOuvrirCopyListeFaces"
      has-modal-card
      class="modal modal-liste-faces">
      <CopyFaceReseau
        :reseau="reseau"
        :disabled="disabled"
        @close="isComponentOuvrirCopyListeFaces = false"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import separerCoordonneesDupliquees from '@/services/catalogue/separerCoordonneesDupliquees';
import Liste from './listeFacesReseauTempo';
import OptionBlocage from './OptionBlocage';
import CopyFaceReseau from '../copyFaceReseau';

const user = createNamespacedHelpers('user');
const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'index',
  props: [
    'reseau',
    'disabled',
    'noUpdate',
    'indexTabs',
    'dateDebut',
    'dateFin',
    'semaine',
    'showAffectations',
    'affectations',
    'horsSecteur',
  ],
  components: {
    appListe: Liste,
    CopyFaceReseau,
    OptionBlocage,
  },
  data() {
    return {
      isComponentDiapoface: false,
      markers: [],
      faces: [],
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        maxWidth: 450,
        maxHeight: 500,
        padding: 10,
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      isComponentOuvrirCopyListeFaces: false,
      dataLoad: false,
      valueTabs: 0,
    };
  },
  computed: {
    ...user.mapGetters({
      afficherAzimut: 'afficherAzimut',
      site: 'site',
    }),
    ...VenteReseauxTempo.mapGetters({
      getCriterePlanning: 'criterePlanning',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
  },
  methods: {
    generateMarker() {
      const facesValides = this.reseau.listeFaces.filter((face) =>
        face.latitude !== 0 && face.longitude !== 0 &&
    Math.abs(face.latitude) > 0.001 && Math.abs(face.longitude) > 0.001,
      );
      facesValides.forEach((face) => {
        if (face.selected) {
          face.color = niveauDispo.COULEUR_SELECTION;
        } else if (this.reseau.couleur) {
          face.color = this.reseau.couleur;
        }
      });
      this.markers = fromTypeToMarkers('facesFromVentesReseaux',
        separerCoordonneesDupliquees(facesValides), this.afficherAzimut);
    },
    selecMarker(marker) {
      if (!this.disabled) {
        marker.selected = !marker.selected;
        marker.faces.forEach((el) => {
          const faceSelected = this.reseau.listeFaces.find((face) => {
            return el.facNum === face.facNum;
          });
          faceSelected.selected = marker.selected;
        });
        this.generateMarker();
      }
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = this.getInfoWindowContent(marker);
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getInfoWindowContent(marker) {
      /* eslint-disable */
      return (
        `<div style="padding:15px" class="card">
        <div class="">
          <div class="columns">
            <div class="column is-6">
              <p>Code Face : <strong>${marker.faces[0].facCode}</strong></p>
              <p>Réseau : <strong>${this.reseau.libelle}</strong></p>
              <p>Adresse : <strong>${marker.faces[0].adresse1}
                <br/>${marker.faces[0].codePostal} ${marker.faces[0].ville}</strong></p>
              <p>Format : <strong>${marker.faces[0].format}</strong></p>
            </div>
            <div class="column">
              <img style="width:100%"
                  src="${marker.faces[0].urlPhoto ? marker.faces[0].urlPhoto : require('@/assets/default-placeholder.png')}"/>
            </div>
          </div>
        </div>
      </div>`);
    },
    exportFacesDispo() {
      const faces = this.reseau.listeFaces.filter((el) => {
        return el.dispo === 3;
      });
      this.exportCsv(faces);
    },
    exportFacesSelect() {
      const faces = this.$refs.appListe.dispoFiltre.filter((el) => el.selected);
      this.exportCsv(faces);
    },
    exportCsv(faces) {
      const keys = Object.keys(this.$refs.appListe.trad);
      let result = '';
      keys.forEach((k, index) => {
        if (this.site !== 'sopa' && (k === 'longueur' || k === 'largeur')) return;
        if (index) result += ';';
        result += this.$refs.appListe.trad[k].replace('↑↓ ', '');
      });
      result += ';\n';
      faces.forEach((obj) => {
        obj.adresseCommercialeLibelle = this.getLibelleAdresse(obj);
        keys.forEach((k, index) => {
          if (this.site !== 'sopa' && (k === 'longueur' || k === 'largeur')) return;
          if (index) result += ';';
          // fait "bourainement,ne doit pas etre repris tel quel"
          if (k === 'dispo') {
            switch (obj[k]) {
              case 1 :
                result += 'Indisponible';
                break;
              case 3 :
                result += 'Disponible';
                break;
              default :
                result += '';
            }
          } else {
            result += obj[k] || '';
          }
        });
        result += ';\n';
      });
      const link = document.createElement('a');
      link.href = 'data:attachment/csv,' + encodeURIComponent(result);
      link.target = '_blank';
      link.download = 'FacesDeMonReseau.csv';
      link.click();
    },
    getLibelleAdresse(face) {
      let adresse = '';
      if (face.adresseCommercialeLibelle1 !== null && face.adresseCommercialeLibelle1) {
        adresse += ' ' + face.adresseCommercialeLibelle1;
      }
      if (face.adresseCommercialeLibelle2 !== null && face.adresseCommercialeLibelle2) {
        adresse += ' ' + face.adresseCommercialeLibelle2;
      }
      if (face.adresseCommercialeLibelle3 !== null && face.adresseCommercialeLibelle3) {
        adresse += ' ' + face.adresseCommercialeLibelle3;
      }
      return adresse.trim();
    },
  },
  async mounted() {
    if (this.noUpdate) {
      this.reseau.extensionOpportunite = {
        faces: [],
      };
    }
    if (this.indexTabs) this.valueTabs = this.indexTabs;
    if (this.dateDebut && this.dateFin) {
      this.reseau.extensionOpportunite.newPeriode = `
        Semaine ${this.semaine}
        du ${moment(this.dateDebut).format('DD MMMM')}
        au  ${moment(this.dateFin).format('DD MMMM YYYY')}`;
    }
    this.dataLoad = true;
    this.generateMarker();
  },
};
</script>

<style scoped>
.lineHeight {
  line-height: 1.5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation/index.vue